export default 'M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1m12 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10M6 13a5 5 0 1 0 0 10 5 5 0 0 0 0-10m12 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10';